import { Box, CircularProgress, Container, Paper } from "@mui/material";
import Card from "./Card";
import Summary from "./Summary";
import FloodMap from "./FloodMap";

export default function Dashboard(props) {
  if (props.estatedProperty && props.estatedProperty[props.selectedItem.key]) {
    let val = props.estatedProperty[props.selectedItem.key];
    if (!Array.isArray(val)) {
      val = [val];
    }
    return (
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        {val.map((v, index) => {
          return (
            <Paper
              key={index}
              sx={{
                mb: 4,
                p: 2,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Card
                label={props.selectedItem.label}
                activeKey={props.selectedItem.key}
                row={v}
                {...props}
              />
            </Paper>
          );
        })}
      </Container>
    );
  } else if (props.loading) {
    return (
      <Box
        sx={{
          display: "flex",
          padding: 20,
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else if (
    props.selectedItem.key === "summary" &&
    props.estatedProperty &&
    props.risk
  ) {
    return (
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Summary {...props} />
      </Container>
    );
  } else if (
    props.selectedItem.key === "flood_map" &&
    props.estatedProperty &&
    props.risk
  ) {
    return <FloodMap {...props} />;
  } else {
    return null;
  }
}
